import React, { useState } from "react";
import { Button } from "src/components/buttons/shadcn-button";
import { LeaveRequest } from "src/redux/types/_attendance.type";
import LeaveDetailDialog from "./LeaveDetailDialog";
import { Badge } from "src/components/ui/Badge";

interface LeaveRequestProps {
  leave: LeaveRequest;
}

const statusColors: Record<LeaveRequest["status"], string> = {
  APPROVED: "bg-green-100 text-green-700 border-green-300",
  PENDING: "bg-yellow-100 text-yellow-700 border-yellow-300",
  REJECTED: "bg-red-100 text-red-700 border-red-300",
};

const LeaveTableRow = ({ leave }: LeaveRequestProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const [selected, setSelected] = useState<LeaveRequest | null>(null);

  const handleOpen = (leave: LeaveRequest) => {
    setSelected(leave);
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(!open);
    setSelected(null);
  };

  return (
    <>
      <tr key={leave.id} className="border-t text-slate-700 text-sm">
        <td className="py-2 px-4">
          <div>
            <p className="capitalize font-medium">
              {leave.employee_name}
            </p>
            <p className="text-sx text-muted">{leave.employee_email}</p>
          </div>
        </td>
        <td className="py-2 px-4">{leave.post}</td>
        <td className="py-2 px-4">
          {new Date(leave.created_at).toLocaleDateString()}
        </td>
        <td className="py-2 px-4">
          {new Date(leave.from_date).toLocaleDateString()}
        </td>
        <td className="py-2 px-4">
          {new Date(leave.to_date).toLocaleDateString()}
        </td>
        <td className="py-2 px-4">
          <span className="px-3 rounded-full bg-blue-400 text-white">{leave.type}</span>
          <p>{leave.days} Days</p>
          </td>
        <td className="py-2 px-4">
          <div className="flex flex-col">
            <Badge
              className={`${statusColors[leave.status]} px-3 rounded-full`}
            >
              {leave.status}
            </Badge>
          </div>
        </td>
        <td className="py-2 px-4">
          <Button
            className="bg-accent hover:bg-[#083A73] transition-all text-white"
            onClick={() => handleOpen(leave)}
          >
            View
          </Button>
        </td>
      </tr>

      {selected && (
        <LeaveDetailDialog leave={selected} open={open} close={handleClose} />
      )}
    </>
  );
};

export default LeaveTableRow;
